export const APIURL = process.env.REACT_APP_API_URL

export const ModuleId = process.env.REACT_APP_MODULE_ID

export const flaggedFeatures = {
  outcomesMonitoring: ['AR']
}

export const auth = {
  inactivityLogoutPromptMinutes: 19,
  inactivityLogoutMinutes: 20
}
